import { Box, Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { CalendarAccountsPreview } from 'src/meetings/components/CalendarAccountsPreview';
import { useCalendarEvents } from 'src/meetings/hooks/useCalendarEvents';
import UnderlineTabs from 'src/UI/page-nav/UnderlineTabs';
import { useCalendars } from '../hooks/useCalendars';
import { UpcomingEventsList } from 'src/meetings/home/UpcomingEventsList';

export const TAB_NAME = {
  ALL: 'All Meetings',
  CLIENT: 'Client Meetings',
};

type Props = {
  tabName: (typeof TAB_NAME)[keyof typeof TAB_NAME];
  onTabChange: (tab: string) => void;
  selectedEventId: string | null;
  onEventSelect: (eventId: string | null) => void;
  onRefetchNeeded: () => void;
  tabNameConstants: {
    ALL: string;
    CLIENT: string;
  };
};

export const UpcomingEventsPanel = ({
  tabName,
  onTabChange,
  selectedEventId,
  onEventSelect,
  onRefetchNeeded,
  tabNameConstants,
}: Props) => {
  const { connecting } = useCalendars();
  const { events, hasNextPage, fetchNextPage, isFetchingNextPage, isLoading } = useCalendarEvents({
    pastOrUpcoming: 'UPCOMING',
    clientMeetingsOnly: tabName === tabNameConstants.CLIENT ? true : undefined,
  });

  return (
    <>
      <Flex align="center" gap="xs" mb="md" p="lg" pb={0}>
        <Text size="lg" fw={FONT_WEIGHTS.semibold} c="gray.10">
          Upcoming events
        </Text>
        <CalendarAccountsPreview />
      </Flex>
      <Box px={'lg'}>
        <UnderlineTabs
          mode="local"
          variant="bordered"
          value={tabName}
          onChange={onTabChange}
          tabs={[
            { value: tabNameConstants.CLIENT, label: 'Clients only' },
            { value: tabNameConstants.ALL, label: 'All meetings' },
          ]}
        />
      </Box>

      <UpcomingEventsList
        events={events}
        selectedEventId={selectedEventId}
        onEventSelect={onEventSelect}
        onRefetchNeeded={onRefetchNeeded}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        isFetchingNextPage={isFetchingNextPage}
        connecting={connecting}
        isLoading={isLoading}
      />
    </>
  );
};
